import React from "react";
import { t } from "ttag";

import { PopupModal as Value } from "@reactivated";

import { ImageTile } from "../MediaGridBlock/ImageTile";
import { Modal, ModalRoot } from "../Modal";
import { usePopupModalIsOpen } from "./usePopupModalIsOpen";

import styles from "./index.module.scss";

interface Props {
    value: Value;
    id?: string;
}

const parseDurationMonths = (raw: string | null | undefined): number => {
    if (!raw) {
        return 0;
    }
    const parsed = parseInt(raw, 10);
    return Number.isNaN(parsed) || parsed < 0 ? 0 : parsed;
};

export const PopupModalBlock = (props: Props) => {
    const dismissalDurationMonths = parseDurationMonths(
        props.value.dismissal_duration_months,
    );
    const [isOpen, handleOpenChange, doNotAskAgain, setDoNotAskAgain] =
        usePopupModalIsOpen(
            props.id || "",
            props.value.delay_seconds,
            !!props.value.content,
            dismissalDurationMonths,
            !!props.value.hide_for_rewards_members,
        );
    if (!props.value.content || !props.id) {
        return null;
    }
    return (
        <ModalRoot open={isOpen} onOpenChange={handleOpenChange}>
            <Modal
                contentLabel={t`Popup notification`}
                className={styles.modalContent}
                overlayClassName={styles.modalOverlay}
                closeClassName={styles.modalClose}
                dismissOnOutsideClick={
                    props.value.dismiss_on_outside_click !== false
                }
            >
                {dismissalDurationMonths > 0 && (
                    <label
                        className={styles.doNotAskAgain}
                        style={
                            {
                                "--checkbox-mobile-font-size": `${
                                    props.value.checkbox_mobile_font_size ||
                                    "16"
                                }px`,
                            } as React.CSSProperties
                        }
                    >
                        <input
                            type="checkbox"
                            checked={doNotAskAgain}
                            onChange={(e) => setDoNotAskAgain(e.target.checked)}
                        />
                        {t`Do not ask me again`}
                    </label>
                )}
                <div className={styles.modalImageContainer}>
                    <ImageTile value={props.value.content} numSiblings={0} />
                </div>
            </Modal>
        </ModalRoot>
    );
};
